<template>
    <section id="logged-details">

        <h1 v-if="!settingsMode">{{loggedUser.alias}}</h1>
        <div class="primary-details" v-if="!settingsMode">
            <input type="file" name="new-avatar" id="new-avatar" class="input-file" @change="uploadNewAvatar"/>

            <label class="avatar" for="new-avatar">
                <img :src="avatarImage"/>
                <div class="upload-overlay"><i class="fa fa-upload"></i></div>
            </label>

            <div class="details">
                <a :href="`/Profile/${loggedUser.stringUrl}`" target="_blank"><i class="fa fa-fw fa-user"></i> My Profile</a>
                <a href="#" @click.prevent="settingsMode = true"><i class="fa fa-fw fa-cog"></i> Settings</a>
                <a href="#" @click.prevent="logout"><i class="fa fa-fw fa-sign-out"></i> Logout</a>
            </div>
        </div>

        <div class="settings" v-if="settingsMode">
            <h1>Settings</h1>
            <label><input type="checkbox" :disabled="savingSettings" v-model="useMetric"> Use Metric</label>
            <label><input type="checkbox" :disabled="savingSettings" v-model="useSwearFilter"> Filter Swear Words</label>
            <label><input type="number" :disabled="savingSettings" v-model="ignoreThreshold"> Auto-ignore Threshold</label>
            <button @click.prevent="saveSettings" :disabled="savingSettings">Save Settings</button>
        </div>

        <div class="friend-requests">

            <template v-if="!showFriendRequests">
                <a href="#" @click.prevent="showFriendRequests = true" class="request-link">
                    <i v-if="!retrievedPendingFriendRequests" class="fa fa-spin fa-circle-o-notch"></i>
                    <span v-if="retrievedPendingFriendRequests">{{pendingFriendRequests.length}}</span>
                    <span>Friend Request</span><span v-if="pendingFriendRequests.length !== 1">s</span>
                </a>
            </template>

            <template v-if="showFriendRequests">
                <a href="#" @click.prevent="showFriendRequests = false" class="return-from-friend-requests"><i class="fa fa-arrow-circle-left"></i> Return</a>

                <loader-large v-if="!retrievedPendingFriendRequests"></loader-large>
                <template v-if="retrievedPendingFriendRequests">

                    <div class="no-pending-requests" v-if="pendingFriendRequests.length === 0">You have no pending friend requests</div>

                    <div v-for="pendingFriendRequest in pendingFriendRequests" class="pending-friend-request">
                        <a :href="`/Profile/${pendingFriendRequest.senderStringUrl}`" target="_blank">
                            <img :src="generateFriendRequestAvatar(pendingFriendRequest)"/>
                        </a>

                        <div class="friend-request-details">
                            <a :href="`/Profile/${pendingFriendRequest.senderStringUrl}`" target="_blank">
                                {{pendingFriendRequest.senderAlias}}
                            </a>

                            <div class="button-container">
                                <button @click.prevent="acceptFriendRequest(pendingFriendRequest)">Accept</button>
                                <button @click.prevent="declineFriendRequest(pendingFriendRequest)">Decline</button>
                            </div>
                        </div>
                    </div>
                </template>
            </template>
        </div>

    </section>
</template>

<script>
    import axios from 'axios';

    export default {
        name: 'LoggedDetails',

        data() {
            return {
                showFriendRequests: false,
                retrievedPendingFriendRequests: false,
                pendingFriendRequests: [],
                settingsMode: false,
                savingSettings: false,
                useSwearFilter: true,
                useMetric: false,
                ignoreThreshold: 90
            }
        },

        computed: {
            loggedUser(){
                let loggedUser = this.$store.state.loggedUserModel;
                if (loggedUser.isLoggedIn) {
                    return loggedUser.info;
                }
            },

            avatarImage(){
                let avatarId = new Date(this.loggedUser.avatarUpdate).getTime();
                if (this.loggedUser && this.loggedUser.hasAvatar) {
                    return `/userdata/avatars/${this.loggedUser.id}.jpg?v=${avatarId}`;
                } else {
                    return '/defaultProfilePic.png';
                }
            }
        },

        methods: {
            logout(){
                this.$store.dispatch('loggedUserModel/logOut', () => {
                    this.$router.push('/');
                });
            },

            uploadNewAvatar(e){
                let input = e.target,
                    avatarFile,
                    formData = new FormData();

                if (input.files.length === 0) {
                    return;
                }

                avatarFile = input.files[0];

                if (input.files[0].size > 2 * 1024 * 1024) {
                    return;
                }

                formData.append('avatarFile', avatarFile);

                axios.post('/api/member/newAvatar', formData);
            },

            generateFriendRequestAvatar(friendRequest){
                let avatarId = new Date(friendRequest.senderAvatarUpdate).getTime();

                if (friendRequest.senderHasAvatar) {
                    return `/userdata/avatars/${friendRequest.senderId}.jpg?v=${avatarId}`;
                } else {
                    return '/defaultProfilePic.png';
                }
            },

            fetchPendingFriendRequests(){
                axios.get('/api/friendRequests').then(
                    (response) => {
                        if (response.data.error) {
                            return;
                        }

                        this.retrievedPendingFriendRequests = true;
                        this.pendingFriendRequests = response.data.requests;
                    }
                )
            },

            acceptFriendRequest(friendRequest){
                axios.post('/api/friendRequests/accept', {
                    friendId: friendRequest.senderId
                });
            },

            declineFriendRequest(friendRequest){
                axios.post('/api/friendRequests/decline', {
                    friendId: friendRequest.senderId
                });
            },

            saveSettings(){
                this.savingSettings = true;

                axios.post('/api/member/settings', {
                    useSwearFilter: this.useSwearFilter,
                    useMetric: this.useMetric,
                    ignoreThreshold: this.ignoreThreshold
                }).then(
                    (response) => {
                        this.$store.dispatch('loggedUserModel/fetchLoggedUserInfo');
                        this.savingSettings = false;
                        this.settingsMode = false;
                    }
                )
            }
        },

        mounted(){
            this.fetchPendingFriendRequests();

            if (this.$store.state.loggedUserModel.isLoggedIn) {
                this.useSwearFilter = this.$store.state.loggedUserModel.info.useSwearFilter;
                this.useMetric = this.$store.state.loggedUserModel.info.useMetric;
                this.ignoreThreshold = this.$store.state.loggedUserModel.info.ignoreThreshold;
            }

        },

        sockets: {
            'updateFriendStatus'(){
                this.fetchPendingFriendRequests();
            }
        }

    }
</script>


// WEBPACK FOOTER //
// LoggedDetails.vue?2bb5919f